import React, { useEffect, useState } from 'react'
import { useParams, Link, useSearchParams, useNavigate } from 'react-router-dom'
import { getServiceById } from '@services/api.business.service'
import { useDispatch, useSelector } from 'react-redux'
import { setGotoScrollY } from '@reducers/contentReducer'
import Loading from '../../components/Loading'
import { AiOutlineLeft } from 'react-icons/ai'
import { HelmetProvider, Helmet } from 'react-helmet-async'
import { Config } from '@Config'
import ServiceContinueShippingBar from './components/ServiceContinueShippingBar'
import ServiceImageList from './components/ServiceImageList'
import ServiceHeader from './components/ServiceHeader'
import ServiceInfo from './components/ServiceInfo'
import { getStoreLink } from 'utils/Helper'

export default function ServiceDetail() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const location = useSelector(state => state.user.location)
  const saveScrollY = useSelector(state => state.content.saveScrollY)
  const isMobile = useSelector(state => state.content.isMobile)
  const [service, setService] = useState(null)
  const { id } = useParams()
  console.log('id111', id)
  const [isLoading, setIsLoading] = useState(false)
  const [searchParams] = useSearchParams()

  // state for the button to toggle
  const [showContinueShoppingBar, setShowContinueShoppingBar] =
    React.useState(false)
  // listen for a scroll activity made by the user
  window.addEventListener('scroll', () => {
    // show the back to top button if the user scroll past 200 px from the top
    setShowContinueShoppingBar(window.scrollY > 180)
  })


  useEffect(() => {
    if (isLoading) return
    setIsLoading(true)
    const fetchService = async () => {
      try {
        const res = await getServiceById({
          service_id: id,
          lat: location?.lat,
          lng: location?.lng,
        })
        const service = res.data
        console.log('get service info', res.data)
        setService(service)
      } catch (error) {
        console.log('get service info', error)
      }
      setIsLoading(false)
    }
    fetchService()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id, location])

  if (!service || isLoading) return <Loading />

  const storeLink = getStoreLink(service?.business?.shortLink, service?.business?.city, service?.business?.province, service?.business?.name)
  console.log('storeLink11', storeLink)
  function onClickContinueShopping() {
    dispatch(setGotoScrollY(saveScrollY))
    navigate(-1)
    // navigate('/search')
  }

  // get header's height by id, the id is header
  const headerHeight = document.getElementById('header')?.offsetHeight

  

  return (
    <HelmetProvider>
      <Helmet>
        <title>
          {service?.title} - {service?.business?.name} - {Config.appName}
        </title>
      </Helmet>
      {showContinueShoppingBar && (
        <ServiceContinueShippingBar
          headerHeight={headerHeight}
          service={service}
          onClickContinueShopping={onClickContinueShopping}
        />
      )}
      <div className='w-full py-[50px] smsize:py-[10px]'>
        <div className='m-auto w-[1280px] flex gap-10 smsize:p-5 smsize:gap-3 smsize:w-full smsize:flex-col'>
          <div className='flex flex-col items-center smsize:w-full'>
            <div className='w-fit smsize:w-full'>
              <Link
                onClick={onClickContinueShopping}
                // to='/search'
                className='mb-[20px] w-fit smsize:justify-start smsize:w-full cursor-pointer items-center justify-center gap-[5px] text-[16px] uppercase text-[#727272] flex'
              >
                <AiOutlineLeft /> Continue shopping
              </Link>
              <ServiceImageList
                service={service}
                isMobile={isMobile}
              />
            </div>
          </div>
          <div className='flex flex-1 flex-col justify-start gap-0 smsize:w-full smsize:flex-col'>
            <ServiceHeader service={service} isMobile={isMobile} />
            <ServiceInfo
              service={service}
              userinfo={null}
            />
          </div>
        </div>
      </div>
    </HelmetProvider>
  )
}
